import { decodeOneOf, encodeOneOf, safeId, safePage, safeSort } from '../../../../domain';
import { ICP_COLUMNS, ICP_WINDOWS } from './icp.types';
import { RestrictedKeys } from '../restricted.key';
import { Places } from '../../../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'ic';
/** Os parametros deste place: vao para o endereco. */
const P = {
    Window: `${PREFIX}a`,
    Segment: `${PREFIX}b`,
    Size: `${PREFIX}c`,
    Tab: `${PREFIX}d`,
    Unsegmented: `${PREFIX}e`,
    Sort: `${PREFIX}f`,
    Page: `${PREFIX}g`
};
/** O codigo de cada aba. */
export const ICP_TAB_CODES = {
    '0': 'companies',
    '1': 'persona'
};
/** As colunas que o scorecard ordena - a lista branca do `safeSort`. */
export const ICP_SORT_FIELDS = ICP_COLUMNS.map((column) => column.field);
/** A ordem de quem abre a tela: o melhor score primeiro, como no painel antigo. */
export const ICP_DEFAULT_SORT = '-score';
/**
 * Os filtros do ICP, a aba e a posicao do scorecard.
 *
 * Tudo no endereco, inclusive a ordem e a pagina do scorecard: `#/hub/icp?icb=3&icf=-engagement`
 * e um link que abre o mesmo recorte para outra pessoa. O padrao de cada um - 30 dias, sem
 * segmento, sem porte, a aba de empresas, o melhor score primeiro, a primeira pagina - nao
 * aparece.
 */
export class IcpKeys extends RestrictedKeys {
    get place() {
        return Places.icp;
    }
    // :: janela
    get windowDays() {
        const days = this._intent.getParameterAsNumber(P.Window);
        return ICP_WINDOWS.find((known) => known === days) ?? 30;
    }
    set windowDays(value) {
        this._intent.setParameter(P.Window, value === 30 ? undefined : value);
    }
    // :: segmento e porte
    get segmentId() {
        return safeId(this._intent.getParameterAsNumber(P.Segment));
    }
    set segmentId(value) {
        this._intent.setParameter(P.Segment, value);
    }
    /** A chave da faixa (`DE_10_A_49`), como o servidor a nomeia: a lista vem dele. */
    get sizeBand() {
        return this._intent.getParameterAsString(P.Size) || undefined;
    }
    set sizeBand(value) {
        this._intent.setParameter(P.Size, value || undefined);
    }
    // :: aba
    get tab() {
        return decodeOneOf(this._intent.getParameterAsString(P.Tab), ICP_TAB_CODES, 'companies');
    }
    set tab(value) {
        this._intent.setParameter(P.Tab, value === 'companies' ? undefined : encodeOneOf(value, ICP_TAB_CODES));
    }
    // :: scorecard
    /** O atalho para classificar: so as empresas que ainda nao tem segmento. */
    get onlyUnsegmented() {
        return this._intent.getParameterAsString(P.Unsegmented) === '1';
    }
    set onlyUnsegmented(value) {
        this._intent.setParameter(P.Unsegmented, value ? '1' : undefined);
    }
    get sort() {
        return safeSort(this._intent.getParameterAsString(P.Sort), ICP_SORT_FIELDS) ?? ICP_DEFAULT_SORT;
    }
    set sort(value) {
        this._intent.setParameter(P.Sort, value === ICP_DEFAULT_SORT ? undefined : value);
    }
    get page() {
        return safePage(this._intent.getParameterAsNumber(P.Page));
    }
    set page(value) {
        this._intent.setParameter(P.Page, value > 1 ? value : undefined);
    }
}
//# sourceMappingURL=icp.key.js.map